import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface AcceleratorEligibleUntilProps {
  item: {
    lastMonthEligibility: string | null;
  };
}

export const AcceleratorEligibleUntil: React.FC<
  AcceleratorEligibleUntilProps
> = ({item}) => {
  const lastMonthEligibility = get(item, 'lastMonthEligibility', null);

  const {tt} = useTranslation('report.record.acceleratorEligibleUntil');
  const formattedDate = getDateUtilDefaultInstance().formatDate(
    lastMonthEligibility,
    'MMMM d, yyyy',
  );

  return (
    <>
      {tt(
        'eligibleThrough',
        generateComponentCallback({
          component: (
            <Text
              variant="body"
              emphasis="medium"
              testID={Reports.reportABEligibleThrough}>
              Eligible through {formattedDate}
            </Text>
          ),
        }),
      )}
    </>
  );
};
